export const money = (value) =>
  value == null || value === ""
    ? "—"
    : new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(Number(value));

export const MECHANISM_OPTIONS = [
  { value: "discretionary", label: "Discretionary" },
  { value: "equal_shares", label: "Equal shares" },
  { value: "floor_area", label: "Floor area" },
];

export const mechanismLabel = (value) =>
  MECHANISM_OPTIONS.find((option) => option.value === value)?.label || "Discretionary";

export const budgetStatusLabel = (status) =>
  status ? status.charAt(0).toUpperCase() + status.slice(1).replaceAll("_", " ") : "";

export const budgetStatusColor = (status) =>
  status === "published" ? "success" : status === "approved" ? "info" : "default";

export const sanitizeMoney = (value) => {
  const cleaned = String(value).replace(/[^0-9.]/g, "");
  const parts = cleaned.split(".");
  if (parts.length <= 1) return cleaned;
  return `${parts[0]}.${parts.slice(1).join("").slice(0, 2)}`;
};

export const sanitizePercent = (value) => {
  const cleaned = String(value).replace(/[^0-9.]/g, "");
  const parts = cleaned.split(".");
  if (parts.length <= 1) return cleaned;
  return `${parts[0]}.${parts.slice(1).join("").slice(0, 4)}`;
};
